export default __webpack_public_path__ + "static/media/doctor.beca9ef3.png";